import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts"
import { round_with_spaces, format_thousands } from "../../../utils/functions"
import stats_font_sizes from "../../../configs/stats_font_sizes.json"
import theme_colors from "../../../configs/theme_colors.json"

const bar_color_1 = theme_colors.ndoh_yellow
const bar_color_2 = theme_colors.insured_yellow
const bar_color_3 = theme_colors.uninsured_yellow
const bar_color_4 = theme_colors.ndoh_green
const bar_color_5 = theme_colors.utilized_green
const bar_color_6 = theme_colors.green_2

const CustomLegendHIVTB = () => {
  return (
    <div style={{ fontSize: 13 }}>
      <span style={{ color: bar_color_1, paddingLeft: 10 }}>■</span> Male HIV
      pos.
      <span style={{ color: bar_color_2, paddingLeft: 10 }}>■</span> Male HIV
      neg.
      <span style={{ color: bar_color_3, paddingLeft: 10 }}>■</span> Male HIV
      unknown
      <br />
      <span style={{ color: bar_color_4, paddingLeft: 10 }}>■</span> Female HIV
      pos.
      <span style={{ color: bar_color_5, paddingLeft: 10 }}>■</span> Female HIV
      neg.
      <span style={{ color: bar_color_6, paddingLeft: 10 }}>■</span> Female HIV
      unknown
    </div>
  )
}

function CustomTooltipHIVTB({ payload, label, active }) {
  if (active) {
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "white",
          fontSize: stats_font_sizes.tooltip_font_size,
          padding: 4,
          border: "black",
          boxShadow: "4px 6px 3px rgba(0, 0, 0, 0.2)",
        }}
      >
        <p style={{ padding: 0, margin: 0, fontWeight: "bold" }}>{label}</p>
        <p
          style={{ padding: 0, margin: 0 }}
        >{`Male HIV pos: ${round_with_spaces(payload[0].value)} people`}</p>
        <p
          style={{ padding: 0, margin: 0 }}
        >{`Male HIV neg: ${round_with_spaces(payload[1].value)} people`}</p>
        <p
          style={{ padding: 0, margin: 0 }}
        >{`Male HIV unknown: ${round_with_spaces(payload[2].value)} people`}</p>
        <p
          style={{ padding: 0, margin: 0 }}
        >{`Female HIV pos: ${round_with_spaces(payload[3].value)} people`}</p>
        <p
          style={{ padding: 0, margin: 0 }}
        >{`Female HIV neg: ${round_with_spaces(payload[4].value)} people`}</p>
        <p
          style={{ padding: 0, margin: 0 }}
        >{`Female HIV unknown: ${round_with_spaces(
          payload[5].value,
        )} people`}</p>
      </div>
    )
  }

  return null
}

export default function HIVTBBarChart({ stats }) {
  const { hivtb } = stats

  const data = hivtb.map(({ name, male, female }) => ({
    name,
    m_pos: male.pos,
    m_neg: male.neg,
    m_unk: male.unknown,
    f_pos: female.pos,
    f_neg: female.neg,
    f_unk: female.unknown,
  }))

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis
          dataKey="name"
          fontSize={stats_font_sizes.y_axis_label_font_size}
        />
        <YAxis
          fontSize={stats_font_sizes.y_axis_label_font_size}
          tickFormatter={(tick) => format_thousands(tick)}
          label={{
            value: "Population",
            style: { textAnchor: "middle" },
            angle: -90,
            position: "left",
            offset: -20,
          }}
        />
        <Tooltip content={CustomTooltipHIVTB} />
        <Legend content={CustomLegendHIVTB} />
        <Bar dataKey="m_pos" stackId="a" fill={bar_color_1} />
        <Bar dataKey="m_neg" stackId="a" fill={bar_color_2} />
        <Bar dataKey="m_unk" stackId="a" fill={bar_color_3} />
        <Bar dataKey="f_pos" stackId="b" fill={bar_color_4} />
        <Bar dataKey="f_neg" stackId="b" fill={bar_color_5} />
        <Bar dataKey="f_unk" stackId="b" fill={bar_color_6} />
      </BarChart>
    </ResponsiveContainer>
  )
}
